import React, { type ReactElement } from 'react'
import { type CustomTab } from 'common/utils/types'
import CustomTabs from 'features/ui/custom-tabs'

import PendingBids from '../pending-bids'
import AcceptedBids from '../accepted-bids'
import WelcomeHeader from '../../ui/welcome-header/WelcomeHeader'

import styles from './BidList.module.scss'

const tabElements: CustomTab[] = [
  {
    title: 'Na čekanju',
    content: <PendingBids />,
  },
  {
    title: 'Prihvaćeni',
    content: <AcceptedBids />,
  },
]

const BidList: React.FC = (): ReactElement => {
  return (
    <div className={styles.container}>
      <WelcomeHeader
        title={'Dobrodošli na stranicu SVI TENDERI.'}
        subtitle={
          'Ovde možete videti spisak svih projekata koji su Vam poslati kao i one za koje ste prihvatili da vidite detalje a još uvek niste poslali ponudu.'
        }
      />
      <CustomTabs tabs={tabElements} />
    </div>
  )
}

export default BidList
